


































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { Action, Getter, Mutation } from 'vuex-class'
import {
    Card,
    CardIndex,
    CardType,
    CardCase,
    HasCard,
    BaseCard,
    BranchCard,
    isBranchedCard,
    isParamCard,
    isOptionsCard,
    HasDirection,
    CardCaseIndex,
    LinkConfig,
    isCustomParameter,
    OptionsCard,
    isExternalCard,
    ScorecardCard,
    isScorecardCard,
    MessageCard
} from '../../../entities/conversation'
import { notifySuccess } from '@/utils/appstore'
import {
    ContextualData
} from '../ConversationValidator'
import BranchedView from './BranchedView.vue'
import BaseCardView from './BaseCardView.vue'
import CardTypeSelector from './CardTypeSelector.vue'
import DropMenu from './DropMenu.vue'
import WhiteCard from './WhiteCard.vue'
import { clone } from '../../../utils/object'
import {
    baseToBranchCard,
    branchToBaseCard,
    blankCard
} from '../../../transforms/conversation'
import { Dict } from '../../../entities/object'
import { IBillingStarterPlanVisibility, isVisibleOnPlan } from '@/utils/plan'
import { IScorecardSetting } from '@/pages/appstore/components/Scorecard/scorecard-settings-entity'
import Dropdown from '@/pages/settings/account/users/components/Dropdown.vue'
import { rtrim } from '@/utils/string'
import { getFieldInterpolations } from "@/utils/customFields"
import Modal from '@/components/Rain/Modals/Modal.vue'
import PortalContainer from '@/mobile/src/components/containers/PortalContainer.vue'

type MenuAction =
    | 'move card up'
    | 'move card down'
    | 'add question above'
    | 'add question below'
    | 'show option values'
    | 'hide option values'
    | 'remove card'

/**
 * Uses:
 *
 * https://vuejs.org/v2/guide/components-slots.html#Scoped-Slots
 * for the branching - note newer versions of vue have a different syntax
 */

@Component<CardMarshaller>({
    components: {
        PortalContainer,
        Modal,
        Dropdown,
        BranchedView,
        BaseCardView,
        CardTypeSelector,
        DropMenu,
        WhiteCard
    }
})
export default class CardMarshaller extends Vue {
    @Prop(Boolean) public hasScorecardFeature!: boolean
    @Prop(Object) public card!: Card
    @Prop(Object) public cardIndex!: CardIndex
    @Prop(Boolean) public flow!: boolean
    @Prop(Boolean) public hasFlows!: boolean
    @Prop(Number) public siblingsCount!: number
    @Prop(Number) public topicKeyUsed!: number

    @Getter public getContextual!: Dict<ContextualData>
    @Getter public getParamsCount!: number
    @Getter public getCalendly!: LinkConfig | null
    @Getter public visibleOnPlan!: IBillingStarterPlanVisibility
    @Getter
    readonly scorecardSettings!: IScorecardSetting[]

    @Action public setCard!: (data: CardIndex & HasCard) => void
    @Action public setBranchedCard!: (data: CardCaseIndex & HasCard) => void
    @Action public syncParam!: (data: CardIndex & { param: string }) => void
    @Action public bumpCard!: (index: CardIndex & HasDirection) => void
    @Action public removeCard!: (index: CardIndex) => void
    @Action public insertCard!: (data: CardIndex & HasCard) => void
    @Action
    reloadScorecardSettings

    @Mutation public setSurveyField
    @Mutation public touchEditedNow

    public canEditOptionKeys = false
    public linkToScorecard = false
    showConfigureScorecardModal = false

    public mounted() {
        const { card } = this
        const canEditOptionKeys =
            !isBranchedCard(card) &&
            isOptionsCard(card) &&
            card.type === 'list' &&
            card.options &&
            card.options.find(({ key, value }) => key !== value)

        if (canEditOptionKeys) {
            this.canEditOptionKeys = true
        }
        this.linkToScorecard = this.getLinkInitialValue()
    }

    // when pick scorecard question type, need to update this value
    @Watch('card')
    public onCardChange() {
        this.linkToScorecard = this.getLinkInitialValue()
    }

    public getLinkInitialValue() {
        return (
            this.isScorecardCard &&
            ((this.card as BranchCard).cases as Array<
                CardCase<OptionsCard>
            >).filter(cardCase => {
                const card = cardCase && cardCase.card
                return (
                    card &&
                    card.options &&
                    card.options.length &&
                    card.options.filter(option => option.badgeId).length > 0
                )
            }).length > 0
        )
    }

    public get isScorecardCard() {
        return (
            this.hasScorecardFeature &&
            (this.card.type === 'scorecard' || this.card.type === 'list') &&
            this.card.hasOwnProperty('match') &&
            (this.card as BranchCard).match === 'rating'
        )
    }

    // when selecting scorecard from list, hide the other UIs like options/conditions
    get selectingScorecardV3() {
        if (!(this.card as any).isScorecard) {
            return false
        }
        return isScorecardCard(this.card) && !this.card.scorecardId
    }

    public get context(): ContextualData | undefined {
        const { sectionIndex, cardIndex } = this.cardIndex
        return this.getContextual[`${sectionIndex}/${cardIndex}`]
    }

    public get scope() {
        return this.context ? this.context.scope : {}
    }

    public get getBranchParamOptions() {
        // can only branch on params in scope that have options
        const general: string[] = ['none']
        const custom: string[] = []

        for (const param in this.scope) {
            if (this.scope.hasOwnProperty(param)) {
                const value = this.scope[param]
                if (isCustomParameter(param)) {
                    custom.push(param)
                } else if (value instanceof Array) {
                    general.push(param)
                }
            }
        }

        return { general, custom }
    }

    public get isBranched() {
        return isBranchedCard(this.card)
    }

    public get isParam() {
        return isParamCard(this.card)
    }

    public get activeBranchMatch() {
        return isBranchedCard(this.card) ? this.card.match : 'none'
    }

    // when toggle off, clear all badge settings
    public toggleLinkScorecard(newValue) {
        this.linkToScorecard = newValue
        if (
            !newValue &&
            this.isScorecardCard &&
            'cases' in this.card &&
            this.card.cases.length
        ) {
            const cases = this.card.cases
            for (let i = 0; i < cases.length; i++) {
                const card = cases[i].card
                if ('options' in card) {
                    this.updateBranchedCard(i, {
                        ...card,
                        ['options']: card.options.map(option => ({
                            ...option,
                            ['badgeId']: ''
                        }))
                    })
                }
            }
        }
    }

    // convert scorecard options to be used in dropdown
    get scorecardOptions() {
        const options = {}
        this.scorecardSettings.forEach(
            setting => (options[setting.id.toString(10)] = setting.name)
        )
        return options
    }

    // switch scorecard, update scorecard topics, but keep manually added dummy topics
    onSelectScorecard(scorecardId: string) {
        const card = this.card as ScorecardCard
        card.scorecardId = parseInt(scorecardId, 10)
        const scorecardSetting = this.scorecardSettings.find(
            setting => setting.id.toString() === scorecardId
        )
        if (!scorecardSetting) {
            return // this should not happen
        }
        const { id, field, scorecardTopics } = scorecardSetting
        const positiveOptions = card.cases[0].card.options
        const defaultOptions = card.cases[1].card.options
        const scorecardTopicPostiveOptions = scorecardTopics.map(topic => ({
            key: topic.id.toString(10), // need to be string
            value: topic.badge_label,
            badgeId: topic.badge,
            scorecardTopicName: topic.topic_name
        }))
        const scorecardTopicDefaultOptions = scorecardTopics.map(topic => ({
            key: topic.id.toString(10), // need to be string
            value: topic.topic_name,
            scorecardTopicName: topic.topic_name
        }))
        card.cases[0].card.param = rtrim(field, '_c') // spec doesn't like _c :(, otherwise saying field is used
        card.cases[1].card.param = rtrim(field, '_c')
        card.cases[0].card.options = [
            ...scorecardTopicPostiveOptions,
            ...positiveOptions.filter(option => !option.scorecardTopicName)
        ]
        card.cases[1].card.options = [
            ...scorecardTopicDefaultOptions,
            ...defaultOptions.filter(option => !option.scorecardTopicName)
        ]
        this.updateCard({ ...card })
    }

    public updateCard(card: Card) {
        const messageCard = card as MessageCard

        if (messageCard && messageCard.param === 'leadQuestion') {
            this.setSurveyField({ field: 'body', value: messageCard.say })
            this.touchEditedNow()
        } else {
            this.setCard({ ...this.cardIndex, card })
        }
    }

    public updateBranchedCard(caseIndex: number, card: BaseCard) {
        if (!isBranchedCard(this.card)) {
            return
        }
        this.setBranchedCard({
            ...this.cardIndex,
            caseIndex,
            card
        })
    }

    onCancelConfigureScorecard() {
        this.showConfigureScorecardModal = false
        this.cancelCard()
    }

    onClickConfigureScorecard() {
        this.showConfigureScorecardModal = false;
        (window as any).open('/appstore/installed/scorecard/configure', '_blank').focus()
        this.cancelCard()
    }

    public async initializeCard(cardType: CardType) {
        // show configure scorecard modal if no scorecard set yet
        if (cardType === 'scorecardv3' && this.scorecardSettings.length < 1) {
            // no scorecard settings found, let's try fetch it first
            await this.reloadScorecardSettings()
            if (this.scorecardSettings.length < 1) {
                this.showConfigureScorecardModal = true
                return
            }
        }
        // todo scorecard3 remove old check
        const newCard = blankCard(
            cardType,
            cardType === 'scorecard' || cardType === 'scorecardv3',
            this.getParamsCount,
            this.topicKeyUsed
        )

        if (isExternalCard(newCard) && this.getCalendly) {
            const { say, link } = this.getCalendly
            return this.updateCard({ ...newCard, say, link })
        }
        this.updateCard(newCard)

        if (cardType === 'jump') {
            notifySuccess('Please pick a value to customize the next question.')
        }
    }

    public cancelCard() {
        // this.updateCard(blankCard(cardType, cardType === 'scorecard', this.getParamsCount))
        // console.debug('Cancel Card called' + this.cardIndex)
        this.removeCard(this.cardIndex)
    }

    public changeBranchMatch(match: string) {
        // card type stays the same, just branch/unbranch or change match param
        const isBranched = this.activeBranchMatch !== 'none'
        const willBeBranched = match !== 'none'

        if (this.activeBranchMatch === match) {
            return
        }

        if (isBranched && willBeBranched) {
            this.updateCard({ ...(this.card as BranchCard), match })
        } else if (isBranched && !willBeBranched) {
            this.updateCard(
                branchToBaseCard(clone({ ...this.card }) as BranchCard)
            )
        } else if (!isBranched && willBeBranched) {
            this.updateCard(
                baseToBranchCard(clone({ ...this.card }) as BaseCard, match)
            )
        }
    }

    public get cardMenuActions(): MenuAction[] {
        const insertOptions: MenuAction[] = [
            'add question above',
            'add question below'
        ]
        const moveOptions: MenuAction[] = ['move card up', 'move card down']

        const options: MenuAction[] =
            this.siblingsCount > 1
                ? [...moveOptions, ...insertOptions]
                : insertOptions

        if (this.card.type === 'list' && !this.linkToScorecard) {
            options.push(
                this.canEditOptionKeys
                    ? 'hide option values'
                    : 'show option values'
            )
        }
        options.push('remove card')
        return options
    }

    public handleCardMenuAction(action: MenuAction) {
        switch (action) {
            case 'move card up':
                this.bumpCard({ ...this.cardIndex, direction: -1 })
                break
            case 'move card down':
                this.bumpCard({ ...this.cardIndex, direction: 1 })
                break
            case 'add question above':
                this.insertCard({
                    ...this.cardIndex,
                    card: blankCard('unknown')
                })
                break
            case 'add question below':
                this.insertCard({
                    sectionIndex: this.cardIndex.sectionIndex,
                    cardIndex: this.cardIndex.cardIndex + 1,
                    card: blankCard('unknown')
                })
                break
            case 'show option values':
                this.canEditOptionKeys = true
                break
            case 'hide option values':
                this.canEditOptionKeys = false
                break
            case 'remove card':
                this.removeCard(this.cardIndex)
        }
    }

    public isVisibleOnPlan(key: string) {
        return isVisibleOnPlan(this, key)
    }
}
